

/**
 * URL Rewrite
 */
const rewriteHistory = function(parameterName, parameterValue) {
    console.log('rewriteHistory() [parameterName, parameterValue]', parameterName, parameterValue);

    let url = new URL(window.location.href);

    url.searchParams.set(parameterName, parameterValue);
    history.replaceState(null, null, url);
};
/**/



const labelMap = {
    'type' : {
        'FULL'  : 'Archicad',
        'START' : 'Start Edition',
        'SOLO'  : 'Solo',
        'BTC'   : 'BIMcloud Team Client',
    }
};



class Select {
    constructor(node, db) {
        console.log('Select constructor(node, db)', node, db);

        let form = node.closest('form');

        this.node = node;
        this.name = node.name;// node.dataset.name;
        this.default = node.dataset.default;
        this.dependecies = node.dataset.dependencies ? node.dataset.dependencies.split('|') : [];
        this.optionSets = { '–': {} };

        db.forEach(record => {
            let label = (labelMap[this.name] && labelMap[this.name][record[this.name]]) 
                ? labelMap[this.name][record[this.name]] 
                : record[this.name];
                
            this.optionSets['–'][label] = record[this.name];

            this.dependecies.forEach(dependecy => {
                if (!this.optionSets[record[dependecy]]) {
                    this.optionSets[record[dependecy]] = {};
                }

                this.optionSets[record[dependecy]][label] = record[this.name];
            });
        });

        this.setOptions('–');
        form.addEventListener('change', this, false);

        console.info('Select.constructor()', `'${this.name}' instanciated with optionSets:`, this.optionSets);
    }

    handleEvent(event) {
        let changedParam = event.target.name;

        // console.info(`Select.handleEvent() @start (${this.name} === ${changedParam}),  (${changedParam} in ${this.dependecies.join(',')})`);

        rewriteHistory(changedParam, event.target.value);

        if (changedParam === this.name || this.dependecies.indexOf(changedParam) === -1) {
            console.info(`Select.handleEvent() @dismiss (${this.name} === ${changedParam}),  (${changedParam} in ${this.dependecies.join(',')})`);
            return;
        }

        console.info(`Select.handleEvent() @handle (${this.name} === ${changedParam}),  (${changedParam} in ${this.dependecies.join(',')})`);

        if (changedParam) {
            this.setOptions(event.target.value);
        }
    }

    setOptions(optionSetName = null) {
        optionSetName = optionSetName || '–';

        console.info('Select.setOptions() [optionSetName, value]', optionSetName, this.node.value);

        if (!this.optionSets[optionSetName]) { return; }

        let select = document.createElement('select');

        /**/
        let orderedList = Object.entries(this.optionSets[optionSetName]).sort((a, b) => {
            if (a[0] < b[0]) { return -1; }
            if (a[0] > b[0]) { return 1; }
        });

        select.appendChild(new Option('All', '–'));
        for (const [key, value] of orderedList) {
            select.appendChild(new Option(key, value));
        }
        /**/

        let value = this.node.value || this.default;// Capture current value
        this.node.innerHTML = select.innerHTML;
        this.node.value = this.node.querySelector(`[value="${value}"]`) ? value : this.node.options[1].value;// Set value to previous if possible

        console.info('Select.setOptions() [select]', select);
    }

    getName() {
        console.info('Select.getName() [this.name]', this.name);
        
        return this.name;
    }

    getValue() {
        console.info('Select.getValue() [this.node.value]', this.node.value);

        return (this.node.value === '–') ? '' : this.node.value;
    }

    setValue(value) {
        console.info('Select.setValue() [this.name, value]', this.name, value);

        this.node.value = value;
        this.triggerChange();
    }

    triggerChange() {
        console.info(`Select.triggerChange() [this] (${this.name})`, this);

        var event = document.createEvent('Event');
        // event.origin = this.name;
        event.initEvent('change', true, true);
        this.node.dispatchEvent(event);
    }
}


export default Select;

